window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    try {
      let $swiper = $('.column-wrapper.swiper');

      if (!$swiper.length) return;

      let mobileCols = parseFloat($swiper.attr('data-mobile-columns'));
      let multicolumnSwiper = new Swiper('.column-wrapper.swiper', {
        slidesPerView: mobileCols,
        slidesPerGroup: 1,
        spaceBetween: 8,
        allowTouchMove: true,
        breakpoints: {
          768: {
            slidesPerView: mobileCols * 2,
            slidesPerGroup: 2,
            spaceBetween: 8,
            allowTouchMove: true,
          },
          1280: {
            slidesPerView: 'auto',
            slidesPerGroupAuto: true,
            spaceBetween: 16,
            allowTouchMove: false,
          },
        },
        navigation: {
          nextEl: '.asc-multicolumn__navigation-wrapper .swiper-button-next',
          prevEl: '.asc-multicolumn__navigation-wrapper .swiper-button-prev',
        },
      });
    } catch (e) {
      console.error(e);
    }
  });
});
